"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.saveInClient = void 0;
/**
 * 将用户的登录信息保存在浏览器中
 * @param key key值
 * @param value value值
 * @param expires 过期时间
 */
function saveInClient(key, value, expires) {
    if (window.localStorage) {
        window.localStorage.setItem(key, value);
    }
    else {
        document.cookie = `${key}=${value}; expires=${expires}; path=/`;
    }
}
exports.saveInClient = saveInClient;
//# sourceMappingURL=SaveInClient.js.map